import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  alpha,
  useTheme,
} from "@mui/material";
import { TaskAlt as TaskAltIcon } from "@mui/icons-material";

interface SignOffDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SignOffDialog: React.FC<SignOffDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
          },
          elevation: 0,
        },
        backdrop: {
          sx: {
            bgcolor: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(4px)",
          },
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: alpha(theme.palette.success.main, 0.12),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2.5,
            boxShadow: `0 4px 14px ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        >
          <TaskAltIcon sx={{ fontSize: 32, color: "success.main" }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Approve Template
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.6 }}
        >
          This will save the template for your department. Future generated
          reports can use this format.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{ flexDirection: "column", gap: 1.5, px: 4, pb: 4, pt: 1 }}
      >
        <Button
          variant="contained"
          color="success"
          fullWidth
          disableElevation
          onClick={onConfirm}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            py: 1.25,
            fontWeight: 600,
          }}
          autoFocus
        >
          Approve & Save
        </Button>
        <Button
          variant="text"
          color="inherit"
          fullWidth
          onClick={onClose}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            py: 1.25,
            fontWeight: 500,
          }}
        >
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignOffDialog;
